module.exports = __webpack_public_path__ + "static/media/implant.7a3cf50f.svg";